import { render, staticRenderFns } from "./albumPlaforms.vue?vue&type=template&id=271083a8&scoped=true&lang=html&"
import script from "./albumPlaforms.vue?vue&type=script&lang=js&"
export * from "./albumPlaforms.vue?vue&type=script&lang=js&"
import style0 from "./albumPlaforms.vue?vue&type=style&index=0&id=271083a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271083a8",
  null
  
)

export default component.exports